import { WorkflowAnalysis } from "../types/types"
import { genericRequest, workflowAnalysisRoute } from "./service"

/**
 * Gets workflow analysis for a given workflow.
 * 
 * @param workflowId of anlysis to fetch
 * 
 * @returns analysis for a given workflow.
 */
export const getWorkflowAnalysis = (workflowId: number): Promise<WorkflowAnalysis[] | Error> => {
  return genericRequest({ url: `${workflowAnalysisRoute}/workflow/${workflowId}`, method: "GET" })
}